import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ "source", "copyIcon", "checkIcon" ]

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()
    await navigator.clipboard.writeText(this.sourceTarget.dataset.value);
    this.copyIconTarget.classList.add('hidden');
    this.checkIconTarget.classList.remove('hidden');

    // Reset back to copy icon after 1.5 seconds
    setTimeout(() => {
      this.copyIconTarget.classList.remove('hidden');
      this.checkIconTarget.classList.add('hidden');
    }, 1500);
  }
}
